import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import type { FunctionComponent } from 'react';

import { ToolbarContainer } from '~/ui/core/rich-editor/RichEditor';
import { ToolbarPlugin } from '~/ui/core/rich-editor/ToolbarPlugin';

import { RichEditorTranscribeButton } from './RichEditorTranscribeButton';

type RichEditorToolbarWithTranscribeProps = {
    readonly disabled?: boolean;
};

export const RichEditorToolbarWithTranscribe: FunctionComponent<RichEditorToolbarWithTranscribeProps> = ({
    disabled = false,
}) => {
    const [editor] = useLexicalComposerContext();

    return (
        <ToolbarContainer className="items-center" id="toolbar">
            <ToolbarPlugin disabled={disabled} />
            <div className="mx-xs h-6 w-px bg-border-subtle" />
            <RichEditorTranscribeButton disabled={disabled} editor={editor} />
        </ToolbarContainer>
    );
};
